import { Box } from "@mui/material";
import CustomButton from "components/common/CustomButton";
import type { PlatformEnumOption } from "features/integrationsBeta/enumLabel";
import DateRangeSelect, { PAST_PRESETS } from "./DateRangeSelect";
import FilterSelect from "./FilterSelect";

export interface RunsFilters {
  status?: string;
  trigger_type?: string;
  started_after?: string;
  started_before?: string;
  finished_after?: string;
  finished_before?: string;
}

interface Props {
  filters: RunsFilters;
  onChange: (filters: RunsFilters) => void;
  statuses: PlatformEnumOption[];
  triggers: PlatformEnumOption[];
  /** Show the trigger-type filter only when the user may see the Trigger column. */
  showTrigger: boolean;
}

export default function RunsFilterBar({
  filters,
  onChange,
  statuses,
  triggers,
  showTrigger,
}: Props) {
  const set = (patch: Partial<RunsFilters>) =>
    onChange({ ...filters, ...patch });

  return (
    <Box
      sx={{ display: "flex", flexWrap: "wrap", gap: 1.5, alignItems: "center" }}
    >
      <FilterSelect
        label="Status"
        value={filters.status ?? ""}
        options={statuses}
        onChange={(v) => set({ status: v || undefined })}
      />
      {showTrigger && (
        <FilterSelect
          label="Trigger"
          value={filters.trigger_type ?? ""}
          options={triggers}
          onChange={(v) => set({ trigger_type: v || undefined })}
        />
      )}
      <DateRangeSelect
        label="Started"
        presets={PAST_PRESETS}
        value={{ after: filters.started_after, before: filters.started_before }}
        onChange={(r) =>
          set({ started_after: r.after, started_before: r.before })
        }
      />
      <DateRangeSelect
        label="Finished"
        presets={PAST_PRESETS}
        value={{
          after: filters.finished_after,
          before: filters.finished_before,
        }}
        onChange={(r) =>
          set({ finished_after: r.after, finished_before: r.before })
        }
      />

      <CustomButton fullWidth={false} onClick={() => onChange({})}>
        Clear Filters
      </CustomButton>
    </Box>
  );
}
